import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=9d49b11a"
import script from "./UserData.vue?vue&type=script&lang=js"
export * from "./UserData.vue?vue&type=script&lang=js"
import style0 from "./UserData.vue?vue&type=style&index=0&id=9d49b11a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports